import apiClient from '../client'
import { logger } from '../../../utils/logger'
import { handleApiError } from './utils'

export const orderOperations = {
    async getOrders() {
        logger.startGroup('POS Operations: Get Orders')
        try {
            logger.debug('Requesting orders')
            const response = await apiClient.get('orders')

            if (!response.data) {
                throw new Error('Invalid orders response')
            }

            logger.debug('Orders response:', response.data)
            logger.info('Orders fetched successfully')
            return {
                success: true,
                data: Array.isArray(response.data) ? response.data : response.data.data || []
            }
        } catch (error) {
            return handleApiError(error)
        } finally {
            logger.endGroup()
        }
    },

    async getOrderById(orderId) {
        logger.startGroup('POS Operations: Get Order By ID')
        try {
            logger.debug('Requesting order:', orderId)
            const response = await apiClient.get(`orders/${orderId}`)

            if (!response.data) {
                throw new Error('Invalid order response')
            }

            logger.debug('Order response:', response.data)
            logger.info('Order fetched successfully')
            return {
                success: true,
                data: response.data
            }
        } catch (error) {
            return handleApiError(error)
        } finally {
            logger.endGroup()
        }
    },

    async updateOrderStatus(orderId, statusData) {
        console.log('🎯 Inicio del proceso de actualización de estado de la orden:', orderId);

        logger.startGroup('POS Operations: Update Order Status');

        try {
            // Registro inicial de los datos recibidos
            console.log('🔍 Datos recibidos para actualizar el estado de la orden:', {
                orderId,
                statusData
            });

            // Validación básica de los parámetros
            if (!orderId) {
                console.error('❌ Error: El ID de la orden no puede estar vacío.');
                throw new Error('El ID de la orden no puede estar vacío.');
            }
            if (!statusData || !statusData.status) {
                console.error('❌ Error: Los datos de estado no pueden estar vacíos o incompletos.');
                throw new Error('Los datos de estado no pueden estar vacíos o incompletos.');
            }

            // Log antes de realizar la llamada a la API
            console.log('📤 Enviando solicitud para actualizar el estado de la orden:', {
                orderId,
                statusData
            });

            // Llamada a la API para actualizar el estado de la orden
            const response = await apiClient.patch(`orders/${orderId}/status`, statusData);

            // Registro de la respuesta de la API
            console.log('✅ Respuesta de la API al actualizar el estado de la orden:', response.data);

            // Registro del éxito de la operación
            console.log('🎉 Estado de la orden actualizado exitosamente:', {
                orderId,
                newStatus: statusData.status
            });

            // Retornar un objeto indicando éxito
            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            // Registro del error capturado
            console.error('❌ Error al actualizar el estado de la orden:', error);

            // Manejo del error utilizando la función handleApiError
            const errorResponse = handleApiError(error);
            console.error('❌ Respuesta del manejo de errores:', errorResponse);

            // Retornar el resultado del manejo de errores
            return errorResponse;
        } finally {
            // Finalización del grupo de logs
            console.log('⏹️ Finalizando el proceso de actualización de estado de la orden.');
            logger.endGroup();
        }
    }
}

export default orderOperations